import { render } from "./SdDocumentViewer.html?vue&type=template&id=66a52cae&ts=true&external"
import script from "./SdDocumentViewer.ts?vue&type=script&lang=ts&external"
export * from "./SdDocumentViewer.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__